<template>
  <div class="cg-leyenda">
    <span v-for="u in unidades" :key="u.uid" class="cg-item">
      <i class="cg-sw" :style="{ background: u.hex }"></i>
      <b>{{ u.alias }}</b>
      <span v-if="u.patente && u.patente !== u.alias" class="cg-pat">{{ u.patente }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "LeyendaUnidades",
  props: { unidades: { type: Array, required: true } },
};
</script>

<style scoped>
.cg-leyenda {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  margin-top: 12px;
}
.cg-item {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12px;
  color: var(--cg-muted);
}
.cg-item b {
  color: var(--cg-text);
  font-weight: 500;
}
.cg-sw {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  display: inline-block;
}
/* Alias primero en peso 500; la patente va como dato secundario en mono. */
.cg-pat {
  font-family: var(--cg-font-mono);
  opacity: 0.65;
}
</style>
